class HeroLogos {
  constructor(el) {
    if (!el) return;

    let index = 0;
    let prev = 0;
    let logos = el.querySelectorAll(".c-hero-logos");

    let timeout;

    function nextTimeout() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        nextLogos();
      }, 5000);
    }
    const nextLogos = () => {
      index = (index + 1) % logos.length;
      logos[prev].style.opacity = 0;
      logos[index].style.opacity = 1;
      prev = index;
      nextTimeout();
    };
    nextTimeout();
  }
}

export default HeroLogos;
